import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadCommands from './commands';

export default grapesjs.plugins.add('drapcode-ai-components', (editor, opts = {}) => {
  const default_blocks = {
    imageToCode: true,
    promptToCode: true,
  };

  const default_types = {
    imageToCode: 'image-to-code',
    promptToCode: 'prompt-to-code',
  };

  const default_labels = {
    imageToCode: 'Image to UI',
    promptToCode: 'Prompt to UI',
  };

  const default_titles = {
    imageButtonTitle: 'Generate',
    promptButtonTitle: 'Generate',
  };

  const default_refs = {
    aiComponentRef: 'imageToCode',
    imageToCodeCustomCode: 'imageToCode' + '__code',
    promptToCodeCustomCode: 'promptToCode' + '__code',
  };

  const default_commands = {
    image_to_code_custom_code: 'image-to-code:open-modal',
    prompt_to_code_custom_code: 'prompt-to-code:open-modal',
  };

  const default_traits = {};

  let options = {
    ...{
      blocks: default_blocks,
      labels: default_labels,
      titles: default_titles,
      types: default_types,
      traits: default_traits,
      category: 'AI Components',
      refs: default_refs,
      commands: default_commands,
      blockAiComponentCode: {},
      propsAiComponentCode: {},
      placeholderContent: `<span>Insert Layout Here</span>`,
      selectArrow: `<div class="gjs-d-s-arrow"></div>`,
      toolbarBtnAiComponentCode: {},
      placeholderScript: `<div style="pointer-events: none; padding: 10px;">
      <svg viewBox="0 0 24 24" style="height: 30px; vertical-align: middle;">
        <path d="M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z"></path>
        </svg>
      Layout with <i>&lt;script&gt;</i> can't be rendered on the canvas
    </div>`,
      imageModalTitle: 'Image to UI using AI',
      promptModalTitle: 'Prompt to UI using AI',
      codeViewOptions: {},
      commandAiComponentCode: {},
      customWrapperMsg: `Built with AI Component`,
      builderAiEngineURL: `/generate-code`,
      builderAiEnginePromptURL: `/generate-code/prompt`,
    },
    ...opts,
  };

  for (let name in options) {
    if (!(name in opts)) opts[name] = options[name];
  }
  loadComponents(editor, opts);
  loadCommands(editor, opts);
});
